var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"introduce",domProps:{"innerHTML":_vm._s(_vm.introduction)}})
}
var staticRenderFns = []

export { render, staticRenderFns }